import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { withViewport } from '../../util/contextHelpers';

import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  ExternalLink,
  SectionCustomerLogos,
  SectionHowItWorks,
  FaqDropdown,
  NamedLink,
  ContactPreFooter,
} from '../../components';
import { TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';
import { BsFillCheckCircleFill } from 'react-icons/bs';

import { IoIosArrowDown } from 'react-icons/io';

import SolutionPageHeroSection from './SolutionPageHeroSection';
import SolutionPageCustomerReviews from './SolutionPageCustomerReviews';

import heroImage from '../../assets/creative-solutions-freelancer-hero-image.webp';
import miikkaImg from '../../assets/pro-miikka-salminen.webp';

import css from './SolutionPages.css';

const CreativeContentSolutionPageComponent = props => {
  const { intl, scrollingDisabled } = props;

  const schemaTitle = intl.formatMessage({ id: 'CreativeContentSolutionPage.schemaTitle' });
  const schemaDescription = intl.formatMessage({
    id: 'CreativeContentSolutionPage.schemaDescription',
  });

  const heroTitle = (
    <FormattedMessage
      id="CreativeContentSolutionPage.heroTitle"
      values={{
        b: chunks => <strong style={{ color: '#1683A3', fontWeight: 600 }}>{chunks}</strong>,
      }}
    />
  );
  const heroSubtitle = intl.formatMessage({ id: 'CreativeContentSolutionPage.heroSubtitle' });
  const heroButtonText = intl.formatMessage({ id: 'CreativeContentSolutionPage.heroButtonText' });

  const handleShowSpaceHome = () => {
    if (typeof window === 'object') {
      window.Intercom('showSpace', 'home');
    }
  };

  const HowItWorksCard = ({ title, description, checkmarkText }) => {
    return (
      <div className={css.howItWorksCard}>
        <div>
          <div className={css.howItWorksCardTitle}>{title}</div>
          <div className={css.howItWorksCardDescription}>{description}</div>
        </div>
        <div className={css.howItWorksCardCheckmarkContainer}>
          <BsFillCheckCircleFill className={css.howItWorksCardCheckmark} />
          {checkmarkText}
        </div>
      </div>
    );
  };

  const sectionHowItWorksHeader = (
    <FormattedMessage id="CreativeContentSolutionPage.sectionHowItWorksHeader" />
  );
  const sectionHowItWorksCardTitle1 = (
    <FormattedMessage id="CreativeContentSolutionPage.sectionHowItWorksCardTitle1" />
  );
  const sectionHowItWorksCardTitle2 = (
    <FormattedMessage id="CreativeContentSolutionPage.sectionHowItWorksCardTitle2" />
  );
  const sectionHowItWorksCardTitle3 = (
    <FormattedMessage id="CreativeContentSolutionPage.sectionHowItWorksCardTitle3" />
  );
  const sectionHowItWorksCardDescription1 = (
    <FormattedMessage id="CreativeContentSolutionPage.sectionHowItWorksCardDescription1" />
  );
  const sectionHowItWorksCardDescription2 = (
    <FormattedMessage id="CreativeContentSolutionPage.sectionHowItWorksCardDescription2" />
  );
  const sectionHowItWorksCardDescription3 = (
    <FormattedMessage id="CreativeContentSolutionPage.sectionHowItWorksCardDescription3" />
  );
  const sectionHowItWorksInfoImageName = (
    <FormattedMessage id="CreativeContentSolutionPage.sectionHowItWorksInfoImageName" />
  );
  const sectionHowItWorksInfoImageText1 = (
    <FormattedMessage id="CreativeContentSolutionPage.sectionHowItWorksInfoImageText1" />
  );
  const sectionHowItWorksInfoImageText2 = (
    <FormattedMessage id="CreativeContentSolutionPage.sectionHowItWorksInfoImageText2" />
  );
  const sectionHowItWorksInfoImageText3 = (
    <FormattedMessage id="CreativeContentSolutionPage.sectionHowItWorksInfoImageText3" />
  );
  const sectionHowItWorksInfoImageText4 = (
    <FormattedMessage id="CreativeContentSolutionPage.sectionHowItWorksInfoImageText4" />
  );
  const sectionHowItWorksCTA = (
    <FormattedMessage id="CreativeContentSolutionPage.sectionHowItWorksCTA" />
  );

  const howItWorksCardTitle1 = (
    <FormattedMessage id="CreativeContentSolutionPage.howItWorksCardTitle1" />
  );
  const howItWorksCardText1 = (
    <FormattedMessage id="CreativeContentSolutionPage.howItWorksCardText1" />
  );
  const howItWorksCardCheckmarkText1 = (
    <FormattedMessage id="CreativeContentSolutionPage.howItWorksCardCheckmarkText1" />
  );
  const howItWorksCardTitle2 = (
    <FormattedMessage id="CreativeContentSolutionPage.howItWorksCardTitle2" />
  );
  const howItWorksCardText2 = (
    <FormattedMessage id="CreativeContentSolutionPage.howItWorksCardText2" />
  );
  const howItWorksCardCheckmarkText2 = (
    <FormattedMessage id="CreativeContentSolutionPage.howItWorksCardCheckmarkText2" />
  );
  const howItWorksCardTitle3 = (
    <FormattedMessage id="CreativeContentSolutionPage.howItWorksCardTitle3" />
  );
  const howItWorksCardText3 = (
    <FormattedMessage id="CreativeContentSolutionPage.howItWorksCardText3" />
  );
  const howItWorksCardCheckmarkText3 = (
    <FormattedMessage id="CreativeContentSolutionPage.howItWorksCardCheckmarkText3" />
  );

  const [faqIsShown, setFaqIsShown] = useState([
    {
      question: <FormattedMessage id="CreativeContentSolutionPage.sectionFAQQuestion1" />,
      answer: (
        <FormattedMessage
          id="CreativeContentSolutionPage.sectionFAQAnswer1"
          values={{
            lineBreak: <br />,
          }}
        />
      ),
      index: 0,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
    {
      question: <FormattedMessage id="CreativeContentSolutionPage.sectionFAQQuestion2" />,
      answer: (
        <FormattedMessage
          id="CreativeContentSolutionPage.sectionFAQAnswer2"
          values={{
            lineBreak: <br />,
          }}
        />
      ),
      index: 1,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
    {
      question: <FormattedMessage id="CreativeContentSolutionPage.sectionFAQQuestion3" />,
      answer: (
        <FormattedMessage
          id="CreativeContentSolutionPage.sectionFAQAnswer3"
          values={{
            lineBreak: <br />,
          }}
        />
      ),
      index: 2,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
    {
      question: <FormattedMessage id="CreativeContentSolutionPage.sectionFAQQuestion4" />,
      answer: (
        <FormattedMessage
          id="CreativeContentSolutionPage.sectionFAQAnswer4"
          values={{
            lineBreak: <br />,
          }}
        />
      ),
      index: 3,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
  ]);

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="CreativeContentSolutionPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.sections}>
            <SolutionPageHeroSection
              title={heroTitle}
              subTitle={heroSubtitle}
              buttonText={heroButtonText}
              imgSrc={heroImage}
              handleShowSpaceHome={handleShowSpaceHome}
            />
            <SectionCustomerLogos
              toShow={[
                'peikko',
                'olefit',
                'eerikkila',
                'corego',
                'helsinki',
                'invesdor',
                'systam',
                'zervant',
              ]}
            />
            <SectionHowItWorks
              header={sectionHowItWorksHeader}
              cardTitle1={sectionHowItWorksCardTitle1}
              cardTitle2={sectionHowItWorksCardTitle2}
              cardTitle3={sectionHowItWorksCardTitle3}
              cardDescription1={sectionHowItWorksCardDescription1}
              cardDescription2={sectionHowItWorksCardDescription2}
              cardDescription3={sectionHowItWorksCardDescription3}
              infoImageName={sectionHowItWorksInfoImageName}
              infoImageText1={sectionHowItWorksInfoImageText1}
              infoImageText2={sectionHowItWorksInfoImageText2}
              infoImageText3={sectionHowItWorksInfoImageText3}
              infoImageText4={sectionHowItWorksInfoImageText4}
              cta={sectionHowItWorksCTA}
              atLandingPage={true}
            />
            <SolutionPageCustomerReviews atLandingPage={false} />
            <div className={css.sectionWhyFreedomly}>
              <div className={css.sectionWhyFreedomlyTitle}>
                <FormattedMessage id="CreativeContentSolutionPage.sectionWhyFreedomlyTitle" />
              </div>
              <div className={css.sectionWhyFreedomlyContent}>
                <div className={css.whyFreedomlyCard}>
                  <div className={css.whyFreedomlyCardTitle}>
                    <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardTitle1" />
                  </div>
                  <div className={css.whyFreedomlyCardText}>
                    <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardText1" />
                  </div>
                  <div className={css.whyFreedomlyCardBulletPoints}>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint11" />
                    </div>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint12" />
                    </div>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint13" />
                    </div>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint14" />
                    </div>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint15" />
                    </div>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint16" />
                    </div>
                  </div>
                </div>
                <div className={css.whyFreedomlyCard}>
                  <div className={css.whyFreedomlyCardTitle}>
                    <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardTitle2" />
                  </div>
                  <div className={css.whyFreedomlyCardText}>
                    <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardText2" />
                  </div>
                  <div className={css.whyFreedomlyCardBulletPoints}>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint21" />
                    </div>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint22" />
                    </div>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint23" />
                    </div>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint24" />
                    </div>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint25" />
                    </div>
                  </div>
                </div>
                <div className={css.whyFreedomlyCard}>
                  <div className={css.whyFreedomlyCardTitle}>
                    <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardTitle3" />
                  </div>
                  <div className={css.whyFreedomlyCardText}>
                    <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardText3" />
                  </div>
                  <div className={css.whyFreedomlyCardBulletPoints}>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint31" />
                    </div>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint32" />
                    </div>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint33" />
                    </div>
                    <div className={css.whyFreedomlyCardBulletPoint}>
                      <BsFillCheckCircleFill className={css.whyFreedomlyCardCheckmark} />
                      <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCardBulletPoint34" />
                    </div>
                  </div>
                </div>
              </div>
              <div className={css.whyFreedomlyCTA}>
                <NamedLink className={css.whyFreedomlyCTAButton} name="SignupPage">
                  <FormattedMessage id="CreativeContentSolutionPage.whyFreedomlyCTA" />
                </NamedLink>
              </div>
            </div>
            <div className={css.sectionFAQContent}>
              <div className={css.sectionFAQTitle}>
                <FormattedMessage id="CreativeContentSolutionPage.sectionFAQTitle" />
              </div>
              <FaqDropdown faqIsShown={faqIsShown} setFaqIsShown={setFaqIsShown} />
            </div>
            <div className={css.sectionHowItWorksContent}>
              <div className={css.howItWorksTitle}>
                <FormattedMessage id="StartSellingInfoPage.howItWorksTitle" />
              </div>
              <div className={css.howItWorksCardContainer}>
                <HowItWorksCard
                  title={howItWorksCardTitle1}
                  description={howItWorksCardText1}
                  checkmarkText={howItWorksCardCheckmarkText1}
                />
                <HowItWorksCard
                  title={howItWorksCardTitle2}
                  description={howItWorksCardText2}
                  checkmarkText={howItWorksCardCheckmarkText2}
                />
                <HowItWorksCard
                  title={howItWorksCardTitle3}
                  description={howItWorksCardText3}
                  checkmarkText={howItWorksCardCheckmarkText3}
                />
              </div>
              <div className={css.howItWorksCTA}>
                <NamedLink className={css.howItWorksCTAButton} name="SignupPage">
                  <FormattedMessage id="OrganizationSolutionPage.howItWorksCTA" />
                </NamedLink>
              </div>
            </div>
          </div>
          <ContactPreFooter />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const { number, shape } = PropTypes;

CreativeContentSolutionPageComponent.propTypes = {
  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired, // from injectIntl
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

const CreativeContentSolutionPage = compose(
  withRouter,
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(CreativeContentSolutionPageComponent);

export default CreativeContentSolutionPage;
